import React, { useContext, useState } from "react";
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Link as RouterLink } from 'react-router-dom';
import APP from '../tools/AppRoutes';
import { PANTONES_PRINCIPALES } from '../tools/Pantones';
import ListItemIcon from '@material-ui/core/ListItemIcon';
// import Context from './../master/Context/SessionContext';
import Context from '../master/Context/SessionContext';
import { makeStyles } from "@material-ui/core/styles";

const Menu = (props) => {
  const { user, menu, marcarMenu } = useContext(Context);
  var rol = JSON.parse(localStorage.getItem('Rol'));

  //Ruta : 'Nombre del SubMenu'
  const breadcrumbNameMap = {
    //[APP.OTROS]: 'Controles varios',
    [APP.CUESTIONARIOS]: 'Cuestionarios',
    [APP.REGISTROS]: 'Registros'
  };

  //CLASES DE ESTILOS
  const MenuStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: 0
    },
    lists: {
      padding: '0px'
    },
    nestedB: {
      color: '#fff',
      backgroundColor: '#b5b7b9',
      borderLeftColor: PANTONES_PRINCIPALES.AZUL,
      borderLeft: '7px solid',
      paddingLeft: '30px'
    },
    nestedG: {
      color: 'White',
      backgroundColor: '#b5b7b9',
      borderLeftColor: PANTONES_PRINCIPALES.VERDE,
      borderLeft: '7px solid',
      paddingLeft: '30px'
    },
    nestedY: {
      color: 'White',
      backgroundColor: '#b5b7b9',
      borderLeftColor: PANTONES_PRINCIPALES.AMARILLO,
      borderLeft: '7px solid',
      paddingLeft: '30px'
    },
    nestedR: {
      color: 'White',
      backgroundColor: '#b5b7b9',
      borderLeftColor: PANTONES_PRINCIPALES.ROJO,
      borderLeft: '7px solid',
      paddingLeft: '30px'
    },
    hover: {
      color: 'White',
      backgroundColor: '#c7c8c9'
    }
  }));

  const classes = MenuStyles();

  ListItemLink.propTypes = {
    open: PropTypes.bool
  };

  //DEVUELVE EL ELEMENTO DEL SUBMENÚ
  function ListItemLink(props) {
    const { to, open, label, id, ...other } = props;
    const primary = breadcrumbNameMap[to];
    const displayText = primary || label; // Usar breadcrumbNameMap si existe, sino usar label

    // Si no hay ruta 'to', es un elemento expandible (con submenús)
    if (!to) {
      return (
        <ListItem button {...other} divider>
          <ListItemText id={id} primary={displayText} />
          {open === true ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
      );
    }

    // Para elementos con ruta, siempre usar RouterLink
    const isActive = `#${to}` === menu.pathname;

    return (
      <li>
        <ListItem button component={RouterLink} to={to} {...other} divider>
          <ListItemText primary={displayText} />
          {isActive && (
            <ListItemIcon>
              <span>&nbsp;►</span>
            </ListItemIcon>
          )}
        </ListItem>
      </li>
    );
  }

  //CLIC QUE MARCA EL MENÚ
  const handleClick = event => {
    const pathname = event.currentTarget.hash;
    marcarMenu({ ...menu, pathname });
  }

  return (
    <>
      {!props.hide ? (<></>) : (
        <div className={classes.root} style={{ height: '100%', background: PANTONES_PRINCIPALES.GRIS }}>
          <nav aria-label="mailbox folders">
            <List className={classes.lists}>
              {user?.TipoAcceso !== 'Usuario' ? (
                <>
                  <ListItemLink to={APP.HOME} label="Clientes" className={classes.nestedB} onClick={handleClick} />
                  {/* <ListItemLink to={APP.CAJA} label="Entrada de texto" className={classes.nestedB} onClick={handleClick} />
                  <ListItemLink to={APP.TABLE} label="Reportes" className={classes.nestedG} onClick={handleClick} />
                  <ListItemLink to={APP.BOTON} label="Acción" className={classes.nestedR} onClick={handleClick} />
                  <ListItemLink to={APP.OTROS} label="Otros" className={classes.nestedY} onClick={handleClick} /> */}
                </>
              ) : (
                <ListItemLink to={APP.HOME} label="Home" className={classes.nestedB} onClick={handleClick} />
              )}
              {/* <ListItemLink className={classes.nestedB} id={"CUESTIONARIOS"} to={APP.CUESTIONARIOS} label={"Administración de cuestionarios"} onClick={handleClick} />
              <ListItemLink className={classes.nestedY} id={"REGISTROS"} to={APP.REGISTROS} label={"Registros"} onClick={handleClick} />
             */}
            </List>
          </nav>
          <div style={{ minHeight: 800, backgroundColor: '#b5b7b9' }} ></div>
        </div>
      )}
    </>
  );
}
export default React.memo(Menu);